import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import TimeLine from '../timeLine'
import { numFormatter, getTokenAndUid } from '../../../lib/utils'
import NibpenGreen from '../../../components/Images/NibpenGreen'
import MonthlyRewardArt from './monthlyRewardCalendar'
import MilestoneArt from './TrophyGuyIcon'
import NotificationCard from './InnerNotificationCard'
import { post, get } from '../../../lib/api'
import { menuItemObj } from '../../../components/PrivatePage'
import { Box, Image, Text } from '../../../designSystem'
import {
  TabsHolder,
  Tab,
  TabNameSpan,
  UnderLine,
  Card,
  CardHeading,
  CardImg,
  CardSubHeading,
  BookAction,
  BookCard,
  TopSection,
  BookTitle,
  AuthorName,
  StatsDiv,
  Metric,
  Count,
  Label,
  daysMissedDiv,
  hr,
  flexCenterDiv,
  titleExpanded,
  timeLeftDiv,
  HelpText,
  DetailsDiv,
  content,
  TimelineDiv,
  ctaBox,
  descriptionCard,
  descriptionText,
  ArrowWhite,
  TimerInfo
} from '../style'
import { AccountContext } from '../../../providers/accountProvider'
import TimeLineROW from '../timelineRow'
import { cautionText3Msg } from '../../Income/Author/constants'
import InfoIcon from '../../../components/Images/InfoIcon'

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const Stats = ({ views, words, chapters, likes, comments }) => (
  <StatsDiv> 
    <Metric>
      <Count>{numFormatter(views || '0').toLocaleString()}</Count>
      <Label>Views</Label>
    </Metric>
    <Metric>
      <Count>{numFormatter(words || '0').toLocaleString()}</Count>
      <Label>Words</Label>
    </Metric>
    <Metric>
      <Count>{(chapters || 0).toLocaleString()}</Count>
      <Label>Chapters</Label>
    </Metric>
    <Metric>
      <Count>{numFormatter(likes || 0).toLocaleString()}</Count>
      <Label>Likes</Label>
    </Metric>
    <Metric>
      <Count>{numFormatter(comments || 0).toLocaleString()}</Count>
      <Label>Comments</Label>
    </Metric>
  </StatsDiv>
)

export const Timer = () => {
  const [time, setTime] = useState({
    hours: '00',
    minutes: '00',
    seconds: '00'
  })
  function getTimeRemaining() {
    const now = moment().utc()
    const timeDiff = moment().utc(now).endOf('day') - now
    const dur = moment.duration(timeDiff)
    return {
      total: timeDiff,
      hours: dur.hours(),
      minutes: dur.minutes(),
      seconds: dur.seconds()
    };
  }
  
  function initializeClock() {
    function updateClock() {
      const t = getTimeRemaining();
      setTime({
        hours: ('0' + t.hours).slice(-2),
        minutes: ('0' + t.minutes).slice(-2),
        seconds: ('0' + t.seconds).slice(-2)
      })
      if (t.total <= 0) {
        clearInterval(timeinterval);
      }
    }
  
    updateClock();
    const timeinterval = setInterval(updateClock, 1000);
  }
  
  useEffect(() => {
    initializeClock()
  }, [])
  return (
    <Box><Text {...timeLeftDiv}>Time left : {time.hours}:{time.minutes}:{time.seconds}</Text></Box>
  )
}

const MonthlyBookCard = ({ hiddenIds, hideCard, author_name, history, book, setTracker, monthly_reward_threshold, milestone_reward_threshold, handleViewStatusClick }) => {
  const [selectedTab,setSelectedTab] = useState(0)
  const [selectedTabName,setSelectedTabName] = useState('Words')
  const [color,setColor] = useState('#1dbebb')
  const { user } = useContext(AccountContext)
  const isMobile = window.screen.width < 600
  const tabs = [
    {
      'name' : 'Words',
      'value' : book.word_count
    },{
      'name' : 'Days Missed',
      'value' : book.daily_tracker.total_days_missed
    },{
      'name' : 'Rewards',
      'value' : 'Rs5000'
    }]
  const handleMonthlyCardOpen = (program, openCard) => {
    if (openCard) {
      handleViewStatusClick(program)
      return
    }
    const { uid } = getTokenAndUid()
    post('/content_api/book.user_application/?is_novel=1', { data: {
      uid,
      id: program.id,
      is_viewed: 1,
    } })
    hideCard(program.id)
  }
  const tabChange = (i,tab) => {
    setSelectedTab(i) 
    setSelectedTabName(tab)
    if(tab === 'Days Missed'){
      const missedDays = book.daily_tracker.days_missed
      setColor(missedDays <= 5 ? '#1dbebb' : missedDays < 10 ? '#f2c602' : '#dc160c') 
    }
    if(tab === 'Words'){
      const createTime = (new Date('2022,01,01')).getTime()
      const diffInTime = (new Date()).getTime() - createTime
      const wordsPerDay = diffInTime / (1000 * 3600 * 24)
      // setColor(missedDays <= 5 ? '#1dbebb' : missedDays < 10 ? '#f2c602' : '#dc160c')
    }
  }
  const { rewards: { monthly: {cycle, word_count}= {}, milestone: {word_count: milestone_word_count}={} } = {} } = book
  const date = new Date(cycle)
  const year = date.getFullYear()
  const month = months[date.getMonth()]
  return (
    <BookCard>
      <TopSection>
        <Image width={[40, 112]} height={[60, 168]} mr={[8, 24]} src={book.image_url} />
        
        <DetailsDiv>
          <BookTitle>{book.book_title}</BookTitle>
          <AuthorName>{author_name}</AuthorName>
          
          {!isMobile && <Box {...ctaBox}>
            <BookAction enabled={1} onClick={() => history.push(`${menuItemObj.novels}/id/${book.book_id}?tab=draft`)}>
              {book.daily_tracker.chapter_missed ? "Add Today’s Chapter" : "Add New Chapter"}
            </BookAction>
            {book.daily_tracker.total_days_missed !== undefined && <Box onClick={() => setTracker(book.daily_tracker.dates_missed)} ><Text  {...daysMissedDiv}>Days Missed : {book.daily_tracker.total_days_missed}</Text></Box>}
          </Box>}
          {!isMobile && book.daily_tracker.chapter_missed && <Timer />}
        </DetailsDiv>
      </TopSection>
      {isMobile && <Box {...ctaBox}>
        <BookAction enabled={1} onClick={() => history.push(`${menuItemObj.novels}/id/${book.book_id}?tab=draft`)}>
          {book.daily_tracker.chapter_missed ? "Add Today’s Chapter" : "Add New Chapter"}
          <ArrowWhite />
        </BookAction>
      </Box>}
      {isMobile && book.daily_tracker.total_days_missed !== undefined && <Box {...ctaBox}><Box onClick={() => setTracker(book.daily_tracker.dates_missed)} ><Text  {...daysMissedDiv}>Days Missed : {book.daily_tracker.total_days_missed}</Text></Box></Box>}
      {isMobile && book.daily_tracker.chapter_missed && <Timer />}
      {book.daily_tracker.chapter_missed && <TimerInfo>
        <InfoIcon width="16" height="16" />
        Calculation on which day, the chapter is published is based on&nbsp;<strong>UTC Time</strong></TimerInfo>}
      {/* <Box {...descriptionCard}>
          <Text {...descriptionText}>You have<strong> missed {book.daily_tracker.total_days_missed} days </strong>in <strong>{month}</strong> month! Please publish regularly to be eligible for monthly rewards &amp;  gain more readership. </Text>
      </Box> */}
        {(book.application_status === 'ongoing' && book.sub_status !== 'open_for_withdrawal' ) && <Box {...descriptionCard}>
          <Text {...descriptionText}>{cautionText3Msg}</Text>
        </Box>}
      <Box {...hr}/>
      <Stats
        views={book.stats && book.stats.total_views}
        chapters={book.chapters_count}
        words={book.word_count}
        likes={book?.stats?.likes}
        comments={book?.stats?.comments}
      />
      {book.rewards_tml && book.rewards_tml.filter(pg => pg.reward_details && pg.reward_details.reward_type === 'monthly_reward').map(program => {
        const isPending = program.action === 'pending'
        const isRejected = program.action === 'rejected'
        const isApproved = program.action === 'approved'
        let formattedTime = ""
        if (program.action_on === 'reward') {
          if (program.reward_details.props.end_date) {
            const date = new Date(program.reward_details.props.end_date)
            const year = date.getFullYear()
            const month = months[date.getMonth()]
            formattedTime = month + " " + year
          }
        }
        return (
          <Box key={program.id}>
            {!hiddenIds.includes(program.id) && <Box {...hr} />}
            <NotificationCard
              program={program}
              toReplace1="{{month}}"
              withReplace1={formattedTime}
              action_type={isPending ? 'pending' : isRejected ? 'rejected' : 'approved'}
              handleClick={() => handleMonthlyCardOpen(program, isPending)}
              button_text={isPending ? 'Reward Status' : 'Okay'}
              hidden={hiddenIds.includes(program.id)}
            />
          </Box>
        )
      })
      }
      <Box>
        <Box {...hr} />
        <Box {...flexCenterDiv}>
          <Text {...titleExpanded}>{`Monthly Rewards Target - ${month} ${year}`}</Text>
        </Box>
        {<Box {...content}>
          {isMobile && <HelpText>
            Update atleast 1 chapter daily and {numFormatter(book.application_threshold)} words monthly to achieve this reward
          </HelpText>}
          <TimelineDiv>
            {!isMobile && <HelpText>
            Update atleast 1 chapter daily and {numFormatter(book.application_threshold)} words monthly to achieve this reward
            </HelpText>}
            {user?.author_visibility === 'india' && <TimeLine
              word_count={book.curr_month_word_count || 0}
              wordCountLabel={`${book.curr_month_word_count || 0} Words`}
              mileStone1={monthly_reward_threshold[0][0]}
              mileStone2={monthly_reward_threshold[1][0]}
              mileStone1Label={`${numFormatter(monthly_reward_threshold[0][0])} Words`}
              mileStone2Label={`${numFormatter(monthly_reward_threshold[1][0])} Words`}
              mileStone1Award={monthly_reward_threshold[0][1]}
              mileStone2Award={monthly_reward_threshold[1][1]}
            />}
            {user?.author_visibility === 'row' && <TimeLineROW
            word_count={book.curr_month_word_count || 0}
            wordCountLabel={`${book.curr_month_word_count || 0} Words`}
            mileStone1={monthly_reward_threshold[0][0]}
            mileStone2={monthly_reward_threshold[1][0]}
            mileStone3={monthly_reward_threshold[2][0]}
            mileStone1Label={`${numFormatter(monthly_reward_threshold[0][0])}`}
            mileStone2Label={`${numFormatter(monthly_reward_threshold[1][0])}`}
            mileStone3Label={`${numFormatter(monthly_reward_threshold[2][0])}`}
            mileStone1Award={monthly_reward_threshold[0][1]}
            mileStone2Award={monthly_reward_threshold[1][1]}
            mileStone3Award={monthly_reward_threshold[2][1]}
          />}
          </TimelineDiv>
          {!isMobile && <Box><MonthlyRewardArt /></Box>}
        </Box>}
      </Box>
      <Box>
        {/* <Box {...hr} />
        <Text {...titleExpanded}>Payment Summary of the Novel</Text>
        <TabsHolder>
          <Tab alwaysActive={true}>
                <TabNameSpan alwaysActive={true}>Period</TabNameSpan>
                <TabValueSpan alwaysActive={true}>{month}</TabValueSpan>
          </Tab>
          {tabs.map((tab, i) => {
            return (
              <Tab key={tab} last={i === tabs.length - 1} active={selectedTab === i} onClick={() => tabChange(i,tab.name)}>
                <TabNameSpan active={selectedTab === i}>{ tab.name }</TabNameSpan>
                <TabValueSpan active={selectedTab === i}>{ tab.value }</TabValueSpan>
              </Tab>
            )
          })}
        </TabsHolder> */}
        <Box display="flex">
          {/* <Card color={color}>
            <Box pt={16}>
                <CardImg><NibpenGreen></NibpenGreen></CardImg>
            </Box>
            <Box px={16}>
                <Box>
                    <CardHeading>
                      {selectedTabName === 'Words' && 'Word Count'}
                      {selectedTabName === 'Days Missed' && 'Missed Days'}
                      {selectedTabName === 'Rewards' && 'Total Rewards'}
                    </CardHeading>
                </Box>
                <Box>
                  <CardSubHeading>
                    {selectedTabName === 'Words' && `You have missed ${book.daily_tracker.total_days_missed} days`}
                    {selectedTabName === 'Days Missed' && `You have missed ${book.daily_tracker.total_days_missed} days`}
                  </CardSubHeading>
                </Box>
            </Box>
          </Card> */}
        </Box>
      </Box>
      {!(book.rewards_tml && book.rewards_tml.find(pg => pg.reward_details && pg.reward_details.reward_type === 'milestone')) && book.rewards.milestone && milestone_reward_threshold && <Box>
        <Box {...hr} />
        <Box {...flexCenterDiv}>
          <Text {...titleExpanded}>Milestone Reward Target</Text>
        </Box>
        <Box {...content}>
          <TimelineDiv>
            <TimeLine
              word_count={milestone_word_count || 0}
              wordCountLabel={`${milestone_word_count || 0} Total Words`}
              mileStone1={milestone_reward_threshold[0][0]}
              mileStone2={milestone_reward_threshold[1][0]}
              mileStone1Label={`Milestone 1 - ${numFormatter(milestone_reward_threshold[0][0])} Words`}
              mileStone2Label={`Milestone 2 - ${numFormatter(milestone_reward_threshold[1][0])} Words`}
              mileStone1Award={milestone_reward_threshold[0][1]}
              mileStone2Award={milestone_reward_threshold[1][1]}
            />
          </TimelineDiv>
          {!isMobile && <Box><MilestoneArt /></Box>}
        </Box>
      </Box>}

      {book.rewards_tml && book.rewards_tml.filter(pg => pg.reward_details && pg.reward_details.reward_type === 'milestone').map(program => {
        return (
          <Box key={program.id}>
            <Box {...hr} />
            <NotificationCard
              isMilestone
              program={program}
              action_type={'approved'}
              button_text={'Okay'}
              toReplace1="{{word_count}}"
              withReplace1={numFormatter(program.reward_details.props.word_limit)}
              toReplace2="{{milestone_no}}"
              withReplace2={program.reward_details.milestone_no}
              handleClick={() => handleMonthlyCardOpen(program, false)}
              hidden={hiddenIds.includes(program.id)}
          />
          </Box>
        )
      })
      }
    </BookCard>
  )
}

export default withRouter(MonthlyBookCard)
